import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Dropdown, positionDropdown } from '../dropdown'
import useViewport from '../hooks/useViewport'
import { Element } from '../html/element'
import classes from './index.module.scss'

const heightArrowTooltip = 9 //set in CSS class box-notice
const DEFAULT_MAX_WIDTH_TOOLTIP = 300

const DropdownTooltip = ({
  containerRef,
  isOpenTooltip,
  zIndexTooltip,
  isI18n,
  text,
  tooltipMaxWidthByContent,
  childStyle,
}) => {
  const { width } = useViewport()

  const [positionTooltip, setPositionTooltip] = useState(
    positionDropdown.TOP_CENTER,
  )

  const tooltipMaxWidth = tooltipMaxWidthByContent
    ? containerRef.current?.getBoundingClientRect().width
    : DEFAULT_MAX_WIDTH_TOOLTIP

  useEffect(() => {
    const { left, right, x } = containerRef.current.getBoundingClientRect()

    if (left < tooltipMaxWidth)
      setPositionTooltip(positionDropdown.TOP_START_RIGHT)
    else if (width - right - x / left < 0)
      setPositionTooltip(positionDropdown.TOP_START_LEFT)
    else if (width - right < tooltipMaxWidth)
      setPositionTooltip(positionDropdown.TOP_END_LEFT)
    else setPositionTooltip(positionDropdown.TOP_CENTER)
  }, [])

  const customPosition = (position) => {
    return {
      ...position,
      top: position?.top ? position.top - 1 : position?.top,
    }
  }

  return (
    <Dropdown
      parentRef={containerRef}
      isShow={isOpenTooltip}
      position={positionTooltip}
      zIndex={zIndexTooltip}
      appendStyle={{ pointerEvents: 'none' }}
      customPosition={customPosition}
      isTooltip
    >
      <Element
        className={`${classes.tooltip} ${
          positionTooltip === positionDropdown.TOP_START_RIGHT
            ? classes.tooltipLeft
            : positionTooltip === positionDropdown.TOP_END_LEFT ||
              positionTooltip === positionDropdown.TOP_START_LEFT
            ? classes.tooltipRight
            : ''
        }`}
        style={{
          bottom: `${heightArrowTooltip}px`,
          maxWidth: `${tooltipMaxWidth}px`,
          boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)',
          color: 'rgb(255, 255, 255)',
          backgroundColor: '#000000',
          opacity: 0.7,
          fontSize: 9,
          ...childStyle,
        }}
      >
        {isI18n ? (
          <span>
            <Translate value={text} className={classes.breakWord} />
          </span>
        ) : (
          <span>
            <span className={classes.breakWord}>{text}</span>
          </span>
        )}
      </Element>
    </Dropdown>
  )
}

DropdownTooltip.propTypes = {
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
  isI18n: PropTypes.bool,
  zIndexTooltip: PropTypes.number,
  containerRef: PropTypes.object.isRequired,
  isOpenTooltip: PropTypes.bool.isRequired,
  dropdownStyle: PropTypes.object,
  childStyle: PropTypes.object,
}

DropdownTooltip.defaultProps = {
  isI18n: true,
  zIndexTooltip: 1,
  dropdownStyle: {},
  childStyle: {},
}

export default DropdownTooltip
